<mat-sidenav-container
  hasBackdrop="true"
  class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0"
>
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <h2 class="text-xl font-semibold leading-8 tracking-tight">
          Direcciones pendientes por aprobar
        </h2>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Gestión de direcciones pendientes de envío a <b>ERP</b>
        </div>
      </div>
      <!-- Header -->
      <div
        class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between"
      >
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
        </div>
      </div>
    </div>

    <div
      class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent"
    >
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">

            <!-- Error state -->
            <div
              *ngIf="error$ | async as error"
              class="flex flex-col items-center py-12 gap-4 text-center"
            >
              <mat-icon color="warn" class="text-6xl w-12 h-12">error</mat-icon>
              <p class="text-gray-600 max-w-md">{{ error }}</p>
              <button mat-button color="primary" (click)="onRefresh()">Reintentar</button>
            </div>

            <!-- Empty state -->
            <div
              *ngIf="!(loading$ | async) && !(error$ | async) && (addresses$ | async)?.length === 0"
              class="flex flex-col items-center py-12 gap-4 text-center"
            >
              <mat-icon class="text-8xl w-16 h-16 text-gray-400">location_off</mat-icon>
              <h3 class="text-lg font-medium text-gray-800 mb-0">No hay direcciones pendientes</h3>
              <p class="text-gray-600 max-w-md mb-0">
                No se encontraron direcciones pendientes de sincronización con los filtros actuales.
              </p>
            </div>

            <!-- Data state -->
            <table
              class="w-full bg-transparent addresses-table"
              mat-table
              [dataSource]="addresses$ | async"
              [matSort]="false"
              *ngIf="!(error$ | async) && (addresses$ | async)?.length > 0"
            >
              <!-- Checkbox Column -->
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="text-center">
                  <span *ngIf="hasSelection()" class="text-sm font-medium">
                    ({{ getSelectedCount() }})
                  </span>
                </th>
                <td mat-cell *matCellDef="let address" class="text-center">
                  <mat-checkbox
                    [checked]="(selectedAddresses$ | async)?.includes(address._id)"
                    (change)="onCheckboxChange($event, address._id)"
                  >
                  </mat-checkbox>
                </td>
              </ng-container>

              <!-- Business Partner Code Column -->
              <ng-container matColumnDef="businessPartnerCode">
                <th mat-header-cell *matHeaderCellDef >Código socio</th>
                <td mat-cell *matCellDef="let address" class="text-sm uppercase leading-tight min-w-[180px]">
                  <div *ngIf="address.businessPartnerCode">
                    <b class="f-10">{{ address.businessPartnerCode }}</b>
                  </div>
                </td>
              </ng-container>

              <!-- Business Partner Name Column -->
              <ng-container matColumnDef="businessPartnerName">
                <th mat-header-cell *matHeaderCellDef >Nombre socio</th>
                <td mat-cell *matCellDef="let address" class="text-sm uppercase leading-tight">
                  {{ address.businessPartnerName }}
                </td>
              </ng-container>

              <!-- Address Type Column -->
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef class="type-column-header">Tipo</th>
                <td mat-cell *matCellDef="let address" class="type-column-cell">
                  <app-address-type-tag [type]="address.type"></app-address-type-tag>
                </td>
              </ng-container>

              <!-- Address Column -->
              <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef >Dirección</th>
                <td mat-cell *matCellDef="let address" class="text-sm uppercase leading-tight">
                  <div class="flex flex-col">
                    <div>{{ address.address }}</div>
                    <div *ngIf="address.reference" class="text-xs text-gray-500 mt-1">
                      {{ address.reference }}
                    </div>
                  </div>
                </td>
              </ng-container>

              <!-- Location Columns -->
              <ng-container matColumnDef="country">
                <th mat-header-cell *matHeaderCellDef  class="px-6 text-left">
                  País
                </th>
                <td mat-cell *matCellDef="let address" class="px-6 text-left text-sm uppercase">
                  <div>
                    {{ address.locationOne?.name || '-' }}
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="department">
                <th mat-header-cell *matHeaderCellDef  class="px-6 text-left">
                  Departamento
                </th>
                <td mat-cell *matCellDef="let address" class="px-6 text-left text-sm uppercase">
                  <div>
                    {{ address.locationTwo?.name || '-' }}
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="city">
                <th mat-header-cell *matHeaderCellDef  class="px-6 text-left">
                  Ciudad
                </th>
                <td mat-cell *matCellDef="let address" class="px-6 text-left text-sm uppercase">
                  <div>
                    {{ address.locationThree?.name || '-' }}
                  </div>
                </td>
              </ng-container>


              <!-- ERP Status Column -->
              <ng-container matColumnDef="erpStatus">
                <th mat-header-cell *matHeaderCellDef  class="px-6 text-left">
                  Estado ERP
                </th>
                <td mat-cell *matCellDef="let address" class="px-6 text-left">
                  <app-address-status-erp-badge [status]="address.statusERP"></app-address-status-erp-badge>
                </td>
              </ng-container>

              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-center actions-column-header">
                  <button
                    *ngIf="hasSelection()"
                    mat-icon-button
                    color="accent"
                    [disabled]="loading$ | async"
                    (click)="onSyncSelected()"
                    matTooltip="Sincronizar seleccionadas"
                    class="text-pink-600"
                  >
                    <mat-icon>sync</mat-icon>
                  </button>
                </th>
                <td mat-cell *matCellDef="let address" class="px-6 py-3 text-left actions-column-cell">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button
                      mat-menu-item
                      (click)="onSyncSingle(address._id)"
                      [disabled]="loading$ | async"
                    >
                      <mat-icon [svgIcon]="'heroicons_outline:arrow-path'"></mat-icon>
                      <span>Sincronizar</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10 bg-white dark:bg-gray-900"
              ></tr>

              <!-- Fila principal -->
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                class="border-b h-16"
              ></tr>
            </table>
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator
            class="z-10"
            [pageSizeOptions]="[50, 100, 150, 200]"
            showFirstLastButtons
            [length]="totalItems$ | async"
            [pageSize]="pageSize"
            (page)="onPageChange($event)"
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>

  <!-- Filtros -->
  <app-filter (onFilterEvent)="onFiltersChanged()" (onCleanEvent)="onRefresh()">
    <form [formGroup]="filterForm">
      <app-filter-section title="Territorio" [expanded]="false" (onExpanded)="onTerritoryExpanded()">
        <app-routes-filters
          [form]="filterForm"
          [territoryWithMongoId]="true"
          [loadData]="loadTerritoryData"
        ></app-routes-filters>
      </app-filter-section>

      <app-filter-section title="Socios de Negocio" [expanded]="false" (onExpanded)="onBusinessPartnerExpanded()">
        <app-business-partners-filters
          [form]="filterForm"
          [businessPartnerWithMongoId]="true"
          [businessPartnerFilter]="false"
          [loadData]="loadBusinessPartnerData"
        ></app-business-partners-filters>
      </app-filter-section>

      <app-filter-section title="Ubicación Geográfica" [expanded]="false" (onExpanded)="onLocationExpanded()">
        <app-multi-location-filters
          [form]="filterForm"
          [country]="true"
          [department]="true"
          [city]="true"
          [multiCountry]="true"
          [multiDepartment]="true"
          [multiCity]="true"
          [loadData]="loadLocationData"
        ></app-multi-location-filters>
      </app-filter-section>
    </form>
  </app-filter>
</mat-sidenav-container>
